exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /opt/yplan/npm_env_auth_timeout/~/react-facebook/~/core-js/library/modules/_wks-ext.js
// module id = 237
// module chunks = 0